// Minimal dataLayer tracking helpers for the paid-traffic landing pages.
// Everything no-ops safely on the server or when no dataLayer is present.

type Params = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

export function pushEvent(name: string, params: Params = {}) {
  if (typeof window === "undefined") return;
  const dl = window.dataLayer;
  if (!Array.isArray(dl)) return;
  dl.push({ event: name, ...params });
}

export const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
] as const;

const STORAGE_KEY = "mi_attribution";

export type Attribution = Record<string, string>;

/** Persist UTM params + landing page/referrer for the session on first load. */
export function captureAttribution(): Attribution {
  if (typeof window === "undefined") return {};
  let stored: Attribution = {};
  try {
    stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}") as Attribution;
  } catch {
    stored = {};
  }

  const params = new URLSearchParams(window.location.search);
  const fresh: Attribution = {};
  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value) fresh[key] = value.slice(0, 200);
  }

  const next: Attribution = {
    ...stored,
    ...fresh,
    landing_page: stored.landing_page || window.location.pathname,
    referrer: stored.referrer ?? document.referrer ?? "",
  };

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* storage disabled – attribution is best-effort */
  }
  return next;
}

export function getAttribution(): Attribution {
  return captureAttribution();
}
